import { render, staticRenderFns } from "./importOrder.vue?vue&type=template&id=3fbbf478"
import script from "./importOrder.vue?vue&type=script&lang=js"
export * from "./importOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports